import React from 'react'
import PropTypes from 'prop-types'
import CircularProgress from '@material-ui/core/CircularProgress'
import { withStyles } from '@material-ui/core/styles'

const styles = theme => ({
  content: {
    // display: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'fixed',
    left: 0,
    top: 0,
    width: '100%',
    height: '100%',
    zIndex: '10000',
    backgroundColor: 'rgba(0, 0, 0, 0.67)'
  },
  progress: {
    color: theme.palette.secondary.main
  }
})

class LoadingComponent extends React.PureComponent {
  render () {
    const classes = this.props.classes

    return (
      <div className={classes.content}>
        <CircularProgress className={classes.progress} size={100} thickness={5} />
      </div>
    )
  }
}

LoadingComponent.propTypes = {
  classes: PropTypes.object.isRequired
}

export default withStyles(styles)(LoadingComponent)
